// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-division {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
  }

  .template-content-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 800px;
    margin: 0 auto;
    margin-bottom: 15px;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
}

.content-template-field {
  display: flex;
  /* align-items: center; */
  align-items: baseline;
  gap: 10px; /* Spacing between label and input */
}

.content-template-field input {
  width: auto;
}

.content-template-field label {
  flex: 0 0 250px;
  text-align: left; 
  font-weight: bold;
}

.content-template-field input[type="text"],
.content-template-field input[type="number"],
.content-template-field select,
.content-template-field textarea {
  flex: 1 1; /* Take up remaining space */
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.content-template-field textarea {
  resize: vertical; /* Allow vertical resizing */
}


/* For Upload Content Field */
.content-template-field-upload {
  display: flex;
  align-items: center; /* Align label and input vertically */
  gap: 10px; /* Spacing between label and input */
}

.content-template-field-upload input {
  width: auto;
}

.content-template-field-upload label {
  flex: 0 0 200px;
  text-align: left; 
  font-weight: bold;
}

.content-template-field-upload input[type="text"],
.content-template-field-upload select,
.content-template-field-upload textarea {
  flex: 1 1; /* Take up remaining space */
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.content-template-field-upload textarea {
  resize: vertical; 
}

.content-template-field-upload small {
  /* color: #373435;
  font-size: 12px;
  text-align: left; */
  font-size: 0.9em;
  color: #44a67e;
  text-align: start;
  font-size: 13px !important;
  font-style: italic;
  width: 100%;
  font-weight: 550;
}

.content-template-field-upload .file-name {
  color: #44a67e !important;
  font-size: 16px !important;
  text-align: start;
}

.file-upload-content {
  display: flex;
  align-items: center;
  flex-direction: column;
}


/* Content Button Style */
.content-form-actions {
  display: flex;
  justify-content: center; /* Align buttons at the center */
  gap: 15px;
  margin-top: 20px;
}

.content-form-actions .btn-submit,
.btn-cancel {
    padding: 10px 20px;
    font-size: 14px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.content-form-actions .btn-submit {
  color: #fff;
  background-color: #44a67e;
  border-color: #44a67e;
}

.content-form-actions .btn-cancel {
    background-color: #fb3d4e;
    color: white;
}

/* .content-form-actions .btn-submit:hover {
    background-color: #45a049;
}

.content-form-actions .btn-cancel:hover {
    background-color: #e53935;
} */


/* ================== */

  .template-radio-btns {
    display: flex;
    gap: 15px;
  }

  .template-radio-btns label {
    display: flex;
    align-items: center;
    gap: 5px; 
    font-weight: normal; 
  }

  .wrap-add-template-management {
    margin: 0 40px;
  }

  /* search filter */
  .senderid-search-filter {
    margin: 20px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    align-items: center;
    gap: 20px;
  }
  
  .senderid-search-filter input {
    width: 250px;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }


  /* Table Styling======================================================= */
  .content-table-container {
    width: 100%;
    overflow-x: auto;
    margin-top: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background: #fff;
  }
  
  .content-template-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }
  
  .content-template-table th,
  .content-template-table td {
    padding: 12px 15px;
    border: 1px solid #ddd;
    font-size: 14px;
  }
  
  .content-template-table th {
    background-color: #f4f4f4;
    color: #373435;
    font-weight: 600;
    text-transform: uppercase;
    text-align: left;
  }
  
  .content-template-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .content-template-table tbody tr:hover {
    background-color:  rgba(255, 204, 41, 0.2);
  }
  
  .content-template-table td {
    color: #373435;
  }
  
  .content-template-table tbody tr:last-child td {
    border-bottom: 2px solid #ffcc29;
  }

  .template-text-cell {
    white-space: pre-wrap;
    word-break: break-word;
  }
  
  
  /* Expand Button */
  .template-expand-btn {
    background: #373435;
    color: #ffcc29;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 16px;
  }
  
  .template-expand-btn:hover {
    background: #ffcc29;
    color: #373435;
  }
  
  /* Expanded Row */
  .template-expanded-row {
    background-color: #fff;
  }
  
  .template-expanded-content {
    padding: 10px;
  }
  
  /* Responsive Styles */
 
/* ------------------------------------------------------------------------------------ */
  


  /* TABLE BUTTONS */
  button.delete-btn {
    padding: 5px 10px;
    background-color: #fb3d4e;
    color: white;
    border: none;
    cursor: pointer;
  }
  
  button.delete-btn:hover {
    background-color: darkred;
  }
  

  /* Response Message */
  .templateResponseMsg {
    background-color: #28a745;
    color: #fff;
    border-radius: 5px;
  }

  .templateResponseMsg p {
    color: #fff;
    margin-top: 10px;
    padding: 10px;
    text-align: left;
  }

  /* Modal Style  */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    max-width: 600px;
    width: 80%;
    position: relative;
  }

  .preview-input-modal {
    /* border: 1px solid #000; */
    padding: 0 10px;
  }
  
  .modal-content h3{
      text-align: center;
      color: #333;
    }
    .modal-content p {
      font-size: 16px;
      margin: 10px 0;
      padding: 10px;
      border: 1px solid #ddd;
      border-radius: 4px;
      background-color: #ffcc29;
      word-wrap: break-word;
      overflow-wrap: break-word;
      max-width: 100%;
      white-space: pre-wrap;
      text-align: left;
    }
    
  
  .modal-content h3 {
    margin-top: 0;
  }

  .modal-footer {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin: 10px;
  }

  .modal-footer button {
    padding: 10px 20px;
    font-size: 14px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .submit-template-button {
    background: #44a67e;
    color: #fff;
    border: none;
  }

  .cancel-template-button {
    background: #fb3d4e;
    color: #fff;
    border: none;
  }


  /* Upload Content */
  
  .upload-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 800px;
    margin: 0 auto; /* Centers the form horizontally */
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .form-group-upload {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .form-group-upload div label {
    display: flex; 
    align-items: center; 
    gap: 5px; 
  }
  
  .form-group-upload div {
    display: flex; 
    gap: 20px; 
    flex-wrap: wrap; 
  }
  
  input[type="radio"] {
    margin-right: 5px;
  }
  
  
  input[type="file"] {
    border: 1px solid #ccc;
    padding: 5px;
    border-radius: 5px;
  }
  
  .form-group-upload input[type="text"], select {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .content-template-field .input-alert-combine {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .content-template-field .note {
    font-size: 0.9em;
    color: #44a67e;
    font-size: 13px !important;
    font-style: italic;
    text-align: start;
    font-weight: 550;
  }

  /* New CSS Code */

.wrap-template-file-button {
  display: flex;
  gap: 15px;
}

.reset-template-files-btn {
  border: none;
  background-color: #dc3545;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
}

.reset-template-files-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/TemplateManagement/TemplateManagement.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,SAAS,EAAE,oCAAoC;AACjD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;EAIE,SAAO,EAAE,4BAA4B;EACrC,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB,EAAE,4BAA4B;AAChD;;;AAGA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB,EAAE,qCAAqC;EAC1D,SAAS,EAAE,oCAAoC;AACjD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,SAAO,EAAE,4BAA4B;EACrC,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;qBAEmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;;AAGA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB,EAAE,gCAAgC;EACzD,SAAS;EACT,gBAAgB;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;;;;;GAMG;;;AAGH,uBAAuB;;EAErB;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA,kBAAkB;EAClB;IACE,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;;EAGA,yEAAyE;EACzE;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;;EAGA,kBAAkB;EAClB;IACE,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA,sBAAsB;;AAExB,yFAAyF;;;;EAIvF,kBAAkB;EAClB;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA,qBAAqB;EACrB;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;MACI,kBAAkB;MAClB,WAAW;IACb;IACA;MACE,eAAe;MACf,cAAc;MACd,aAAa;MACb,sBAAsB;MACtB,kBAAkB;MAClB,yBAAyB;MACzB,qBAAqB;MACrB,yBAAyB;MACzB,eAAe;MACf,qBAAqB;MACrB,gBAAgB;IAClB;;;EAGF;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;;;EAGA,mBAAmB;;EAEnB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,cAAc,EAAE,kCAAkC;IAClD,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;;EAGA;IACE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,iBAAiB;;AAEnB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".section-division {\r\n    display: flex;\r\n    gap: 15px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .template-content-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    margin-bottom: 15px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n    padding: 20px;\r\n    background-color: #fff;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.content-template-field {\r\n  display: flex;\r\n  /* align-items: center; */\r\n  align-items: baseline;\r\n  gap: 10px; /* Spacing between label and input */\r\n}\r\n\r\n.content-template-field input {\r\n  width: auto;\r\n}\r\n\r\n.content-template-field label {\r\n  flex: 0 0 250px;\r\n  text-align: left; \r\n  font-weight: bold;\r\n}\r\n\r\n.content-template-field input[type=\"text\"],\r\n.content-template-field input[type=\"number\"],\r\n.content-template-field select,\r\n.content-template-field textarea {\r\n  flex: 1; /* Take up remaining space */\r\n  padding: 8px;\r\n  font-size: 14px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.content-template-field textarea {\r\n  resize: vertical; /* Allow vertical resizing */\r\n}\r\n\r\n\r\n/* For Upload Content Field */\r\n.content-template-field-upload {\r\n  display: flex;\r\n  align-items: center; /* Align label and input vertically */\r\n  gap: 10px; /* Spacing between label and input */\r\n}\r\n\r\n.content-template-field-upload input {\r\n  width: auto;\r\n}\r\n\r\n.content-template-field-upload label {\r\n  flex: 0 0 200px;\r\n  text-align: left; \r\n  font-weight: bold;\r\n}\r\n\r\n.content-template-field-upload input[type=\"text\"],\r\n.content-template-field-upload select,\r\n.content-template-field-upload textarea {\r\n  flex: 1; /* Take up remaining space */\r\n  padding: 8px;\r\n  font-size: 14px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.content-template-field-upload textarea {\r\n  resize: vertical; \r\n}\r\n\r\n.content-template-field-upload small {\r\n  /* color: #373435;\r\n  font-size: 12px;\r\n  text-align: left; */\r\n  font-size: 0.9em;\r\n  color: #44a67e;\r\n  text-align: start;\r\n  font-size: 13px !important;\r\n  font-style: italic;\r\n  width: 100%;\r\n  font-weight: 550;\r\n}\r\n\r\n.content-template-field-upload .file-name {\r\n  color: #44a67e !important;\r\n  font-size: 16px !important;\r\n  text-align: start;\r\n}\r\n\r\n.file-upload-content {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n}\r\n\r\n\r\n/* Content Button Style */\r\n.content-form-actions {\r\n  display: flex;\r\n  justify-content: center; /* Align buttons at the center */\r\n  gap: 15px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.content-form-actions .btn-submit,\r\n.btn-cancel {\r\n    padding: 10px 20px;\r\n    font-size: 14px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n.content-form-actions .btn-submit {\r\n  color: #fff;\r\n  background-color: #44a67e;\r\n  border-color: #44a67e;\r\n}\r\n\r\n.content-form-actions .btn-cancel {\r\n    background-color: #fb3d4e;\r\n    color: white;\r\n}\r\n\r\n/* .content-form-actions .btn-submit:hover {\r\n    background-color: #45a049;\r\n}\r\n\r\n.content-form-actions .btn-cancel:hover {\r\n    background-color: #e53935;\r\n} */\r\n\r\n\r\n/* ================== */\r\n\r\n  .template-radio-btns {\r\n    display: flex;\r\n    gap: 15px;\r\n  }\r\n\r\n  .template-radio-btns label {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px; \r\n    font-weight: normal; \r\n  }\r\n\r\n  .wrap-add-template-management {\r\n    margin: 0 40px;\r\n  }\r\n\r\n  /* search filter */\r\n  .senderid-search-filter {\r\n    margin: 20px auto;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: end;\r\n    align-items: center;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .senderid-search-filter input {\r\n    width: 250px;\r\n    padding: 12px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n  }\r\n\r\n\r\n  /* Table Styling======================================================= */\r\n  .content-table-container {\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    margin-top: 20px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n    background: #fff;\r\n  }\r\n  \r\n  .content-template-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    text-align: left;\r\n  }\r\n  \r\n  .content-template-table th,\r\n  .content-template-table td {\r\n    padding: 12px 15px;\r\n    border: 1px solid #ddd;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .content-template-table th {\r\n    background-color: #f4f4f4;\r\n    color: #373435;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n    text-align: left;\r\n  }\r\n  \r\n  .content-template-table tbody tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .content-template-table tbody tr:hover {\r\n    background-color:  rgba(255, 204, 41, 0.2);\r\n  }\r\n  \r\n  .content-template-table td {\r\n    color: #373435;\r\n  }\r\n  \r\n  .content-template-table tbody tr:last-child td {\r\n    border-bottom: 2px solid #ffcc29;\r\n  }\r\n\r\n  .template-text-cell {\r\n    white-space: pre-wrap;\r\n    word-break: break-word;\r\n  }\r\n  \r\n  \r\n  /* Expand Button */\r\n  .template-expand-btn {\r\n    background: #373435;\r\n    color: #ffcc29;\r\n    border: none;\r\n    padding: 5px 10px;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .template-expand-btn:hover {\r\n    background: #ffcc29;\r\n    color: #373435;\r\n  }\r\n  \r\n  /* Expanded Row */\r\n  .template-expanded-row {\r\n    background-color: #fff;\r\n  }\r\n  \r\n  .template-expanded-content {\r\n    padding: 10px;\r\n  }\r\n  \r\n  /* Responsive Styles */\r\n \r\n/* ------------------------------------------------------------------------------------ */\r\n  \r\n\r\n\r\n  /* TABLE BUTTONS */\r\n  button.delete-btn {\r\n    padding: 5px 10px;\r\n    background-color: #fb3d4e;\r\n    color: white;\r\n    border: none;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  button.delete-btn:hover {\r\n    background-color: darkred;\r\n  }\r\n  \r\n\r\n  /* Response Message */\r\n  .templateResponseMsg {\r\n    background-color: #28a745;\r\n    color: #fff;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  .templateResponseMsg p {\r\n    color: #fff;\r\n    margin-top: 10px;\r\n    padding: 10px;\r\n    text-align: left;\r\n  }\r\n\r\n  /* Modal Style  */\r\n  .modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .modal-content {\r\n    background: white;\r\n    padding: 20px;\r\n    border-radius: 5px;\r\n    max-width: 600px;\r\n    width: 80%;\r\n    position: relative;\r\n  }\r\n\r\n  .preview-input-modal {\r\n    /* border: 1px solid #000; */\r\n    padding: 0 10px;\r\n  }\r\n  \r\n  .modal-content h3{\r\n      text-align: center;\r\n      color: #333;\r\n    }\r\n    .modal-content p {\r\n      font-size: 16px;\r\n      margin: 10px 0;\r\n      padding: 10px;\r\n      border: 1px solid #ddd;\r\n      border-radius: 4px;\r\n      background-color: #ffcc29;\r\n      word-wrap: break-word;\r\n      overflow-wrap: break-word;\r\n      max-width: 100%;\r\n      white-space: pre-wrap;\r\n      text-align: left;\r\n    }\r\n    \r\n  \r\n  .modal-content h3 {\r\n    margin-top: 0;\r\n  }\r\n\r\n  .modal-footer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 10px;\r\n    margin: 10px;\r\n  }\r\n\r\n  .modal-footer button {\r\n    padding: 10px 20px;\r\n    font-size: 14px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .submit-template-button {\r\n    background: #44a67e;\r\n    color: #fff;\r\n    border: none;\r\n  }\r\n\r\n  .cancel-template-button {\r\n    background: #fb3d4e;\r\n    color: #fff;\r\n    border: none;\r\n  }\r\n\r\n\r\n  /* Upload Content */\r\n  \r\n  .upload-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    max-width: 800px;\r\n    margin: 0 auto; /* Centers the form horizontally */\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n    padding: 20px;\r\n    background-color: #fff;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .form-group-upload {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 15px;\r\n  }\r\n  \r\n  .form-group-upload div label {\r\n    display: flex; \r\n    align-items: center; \r\n    gap: 5px; \r\n  }\r\n  \r\n  .form-group-upload div {\r\n    display: flex; \r\n    gap: 20px; \r\n    flex-wrap: wrap; \r\n  }\r\n  \r\n  input[type=\"radio\"] {\r\n    margin-right: 5px;\r\n  }\r\n  \r\n  \r\n  input[type=\"file\"] {\r\n    border: 1px solid #ccc;\r\n    padding: 5px;\r\n    border-radius: 5px;\r\n  }\r\n  \r\n  .form-group-upload input[type=\"text\"], select {\r\n    padding: 8px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  .content-template-field .input-alert-combine {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n\r\n  .content-template-field .note {\r\n    font-size: 0.9em;\r\n    color: #44a67e;\r\n    font-size: 13px !important;\r\n    font-style: italic;\r\n    text-align: start;\r\n    font-weight: 550;\r\n  }\r\n\r\n  /* New CSS Code */\r\n\r\n.wrap-template-file-button {\r\n  display: flex;\r\n  gap: 15px;\r\n}\r\n\r\n.reset-template-files-btn {\r\n  border: none;\r\n  background-color: #dc3545;\r\n  color: #fff;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n}\r\n\r\n.reset-template-files-btn:disabled {\r\n  background-color: #ccc;\r\n  cursor: not-allowed;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
